import http from "./http.service";

//category
async function getCategoryList(payload) {
  http.setToken(localStorage.getItem("token"));
  const response = await http.get(
    process.env.REACT_APP_API_URL +
      `/category?length=${9999}&start=${0}&search=${""}&status=${"active"}`,
    payload,
  );
  return response.data;
}

//product
async function getProductList(payload, options = {}) {
  http.setToken(localStorage.getItem("token"));

  let url = `${process.env.REACT_APP_API_URL}/user_products?category=${payload.category}&start=${payload.start}&length=${payload.length}`;

  if (payload.hasOwnProperty("search")) {
    url += `&search=${payload.search}`;
  }

  // if (payload.hasOwnProperty("brand") && Array.isArray(payload.brand)) {
  //   payload.brand.forEach((id) => {
  //     url += `&brand[]=${id}`;
  //   });
  // }

  if (payload.hasOwnProperty("brand") && Array.isArray(payload.brand)) {
    payload.brand.forEach((id) => {
      url += `&brand[]=${id}`;
    });
  }

  if (payload.hasOwnProperty("car_model") && Array.isArray(payload.car_model)) {
    payload.car_model.forEach((id) => {
      url += `&car_model[]=${id}`;
    });
  }

  if (payload.hasOwnProperty("body_type") && Array.isArray(payload.body_type)) {
    payload.body_type.forEach((value) => {
      url += `&body_type[]=${value}`;
    });
  }

  if (payload.hasOwnProperty("location") && Array.isArray(payload.location)) {
    payload.location.forEach((value) => {
      url += `&location[]=${value}`;
    });
  }

  if (payload.hasOwnProperty("show_room") && Array.isArray(payload.show_room)) {
    payload.show_room.forEach((value) => {
      url += `&show_room[]=${value}`;
    });
  }

  if (payload.hasOwnProperty("price") && Array.isArray(payload.price)) {
    url += `&price=${payload.price?.[0] || 0}-${payload.price?.[1] || 0}`;
  }

  if (payload.hasOwnProperty("year") && Array.isArray(payload.year)) {
    if (payload.year?.[0] || payload.year?.[1]) {
      url += `&year=${payload.year?.[0] || 0}-${payload.year?.[1] || 0}`;
    }
  }

  if (payload.hasOwnProperty("sort")) {
    url += `&sort.price=${payload.sort}`;
  }

  const response = await http.get(url);
  // {
  //   signal: options.signal,
  // });

  return response.data;
}

async function getProductInfo(payload) {
  http.setToken(localStorage.getItem("token"));
  const response = await http.get(
    process.env.REACT_APP_API_URL + `/product/${payload.id}`,
    payload,
  );
  return response.data;
}

async function saveProduct(payload) {
  http.setToken(localStorage.getItem("token"));
  const response = await http.post(
    process.env.REACT_APP_API_URL + `/saved_cars`,
    payload,
  );
  return response.data;
}

//order
async function getPaymentMethods(payload) {
  http.setToken(localStorage.getItem("token"));
  const response = await http.get(
    process.env.REACT_APP_API_URL + `/get_all_channels`,
    payload,
  );
  return response.data;
}

async function getOrderList(payload) {
  http.setToken(localStorage.getItem("token"));
  let url = `${process.env.REACT_APP_API_URL}/orders?start=${payload.start || 0}&length=${payload.length || 999999}`;

  if (payload.hasOwnProperty("status")) {
    url += `&status=${payload.status}`;
  }

  const response = await http.get(url);

  return response.data;
}

async function payOrder(payload) {
  http.setToken(localStorage.getItem("token"));
  const response = await http.post(
    process.env.REACT_APP_API_URL + `/orders/${payload.order_id}/pay`,
    payload,
  );
  return response.data;
}

async function createOrder(payload) {
  http.setToken(localStorage.getItem("token"));
  const response = await http.post(
    process.env.REACT_APP_API_URL + `/product/${payload.product_id}/reserve`,
    payload,
  );
  return response.data;
}

async function createIdentity(payload) {
  http.setToken(localStorage.getItem("token"));
  const response = await http.post(
    process.env.REACT_APP_API_URL + `/orders/${payload.order_id}/identity`,
    payload.data,
  );
  return response.data;
}

async function createFinance(payload) {
  http.setToken(localStorage.getItem("token"));
  const response = await http.post(
    process.env.REACT_APP_API_URL + `/orders/${payload.order_id}/finance`,
    payload,
  );
  return response.data;
}

async function createVso(payload) {
  http.setToken(localStorage.getItem("token"));
  const response = await http.post(
    process.env.REACT_APP_API_URL + `/orders/${payload.order_id}/vso`,
    payload.data,
  );
  return response.data;
}

async function createInsurance(payload) {
  http.setToken(localStorage.getItem("token"));
  const response = await http.post(
    process.env.REACT_APP_API_URL + `/orders/${payload.order_id}/insurance`,
    payload.data,
  );
  return response.data;
}

//profile
async function getProfile(payload) {
  http.setToken(localStorage.getItem("token"));
  const response = await http.get(
    process.env.REACT_APP_API_URL + `/profile`,
    payload,
  );
  return response.data;
}

async function getReferral(payload) {
  http.setToken(localStorage.getItem("token"));
  const response = await http.get(
    process.env.REACT_APP_API_URL + `/referral`,
    payload,
  );
  return response.data;
}

async function updateProfile(payload) {
  http.setToken(localStorage.getItem("token"));
  const response = await http.post(
    process.env.REACT_APP_API_URL + `/update_profile`,
    payload,
  );
  return response.data;
}

//common
async function getBrandList(payload) {
  http.setToken(localStorage.getItem("token"));
  const response = await http.get(
    process.env.REACT_APP_API_URL + `/brand?start=${0}&length=${9999}`,
    payload,
  );
  return response.data;
}

async function getModelList(payload) {
  http.setToken(localStorage.getItem("token"));
  const response = await http.get(
    process.env.REACT_APP_API_URL + `/model?start=${0}&length=${9999}`,
    payload,
  );
  return response.data;
}

async function getTopSearch(payload) {
  http.setToken(localStorage.getItem("token"));
  const response = await http.get(
    process.env.REACT_APP_API_URL + `/top_search?limit=${8}`,
    payload,
  );
  return response.data;
}

async function getShowroomList(payload) {
  http.setToken(localStorage.getItem("token"));
  const response = await http.get(
    process.env.REACT_APP_API_URL + `/show_room`,
    payload,
  );
  return response.data;
}

async function getConsignList(payload) {
  http.setToken(localStorage.getItem("token"));

  let url = `${process.env.REACT_APP_API_URL}/consignment?start=${payload.start || 0}&length=${payload.length || 999999}`;

  if (payload.hasOwnProperty("status")) {
    url += `&status=${payload.status}`;
  }

  const response = await http.get(url);

  return response.data;
}

async function createConsign(payload) {
  http.setToken(localStorage.getItem("token"));
  const response = await http.post(
    process.env.REACT_APP_API_URL + `/consignment`,
    payload,
  );
  return response.data;
}

const apiService = {
  getProductList,
  getProductInfo,
  saveProduct,
  getCategoryList,

  createOrder,
  payOrder,
  getOrderList,
  getPaymentMethods,

  createIdentity,
  createFinance,
  createVso,
  createInsurance,
  // getPaymentList,

  getProfile,
  updateProfile,
  getReferral,

  getBrandList,
  getModelList,
  getTopSearch,
  getShowroomList,

  getConsignList,
  createConsign,
};

export default apiService;
